import { MessageMedium, PaginationInput, SortInput } from 'modules/graphql';
import { Dispatch, SetStateAction } from 'react';

export enum PAGE {
  CAMPAIGN_CREATION = 'Campaign Create',
  CAMPAIGN_MEDIUMS = 'Campaign Mediums',
  CAMPAIGN_SEARCH = 'Campaign Search',
  HOME_PAGE = 'Home Page',
  JOURNEY_CREATION = 'Journey Create',
  JOURNEY_SEARCH = 'Journey Search',
  SNIPPET_SEARCH = 'Snippet Search',
  TEMPLATE_CREATION = 'Template Create',
  TEMPLATE_MEDIUMS = 'Template Mediums',
  TEMPLATE_SEARCH = 'Template Search',
  USER_SEARCH = 'User Search',
}

export type NavigateState = {
  id?: number | string;
  isExternal?: boolean;
  path: string;
  pageName?: string;
};

export type PageState = {
  data?: {
    templateMedium?: string; // should be enum?
  };
  page: PAGE;
  previousPage?: PAGE;
};

export type GraphQLVariables = {
  search?: string;
  sort?: SortInput;
  pagination?: PaginationInput;
};

export type MediumOptions = {
  [key: string]: {
    Icon: React.FC;
    id: string;
    label: string;
    modalLabel: string;
    slug: MessageMedium;
  };
};

export type CommandItem = {
  /** Feature flags that may be required to create resources */
  featureFlags?: string[];
  /** Label for the action */
  name: string;
  /** Page to display in Quick Actions Menu */
  page?: PAGE;
  /** Permissions that may be required to create resources */
  permissions?: number[];
  /** Page to navigate to */
  url?: string;
};

export type SetCount = Dispatch<SetStateAction<number>>;

export type NavigationItem = {
  /** Feature flags that may be required to view the page */
  featureFlags?: string[];
  /** Determines if navigation uses React Router, can be conditional based on feature flags */
  isExternal?: boolean | ((flags: Record<string, boolean>) => boolean);
  /** Route name to display */
  name: string;
  /** Route path to navigate */
  path: string;
  /** User permissions that may be required to view the page */
  permissions?: number[];
  /** If true, at least one of the feature flags is required to view the page; if false/undefined, default behavior: all flags are required to view the page. */
  requireOnlyOneFlag?: boolean;
};
